import React from "react"
import Shelter from "../Shelter"
import { PCViewRoot } from "../Common/PCViewContext"

const ShelterPage = (props) => {
  return (
    <PCViewRoot>
      <Shelter {...props} />
    </PCViewRoot>
  )
}
export default ShelterPage
